import { render, staticRenderFns } from "./CourseSemester.vue?vue&type=template&id=2ebe6cb1&"
import script from "./CourseSemester.vue?vue&type=script&lang=js&"
export * from "./CourseSemester.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports